<template>
  <DynamicFormHolder
    is-dialog
    :form-name="formName"
    :form-sent-action="formSentAction"
    :steps-before="stepsBefore"
    :steps-after-form="stepsAfterForm"
  />
</template>

<script>
export default {
  name: 'DashboardThematicCounsellingForm',
  props: {
    formName: {
      type: String,
      required: true
    },
    formSentAction: {
      type: Function,
      required: true
    },
    stepsBefore: {
      type: Array,
      required: false
    },
    stepsAfterForm: {
      type: Array,
      required: false
    }
  }
};
</script>
